import styles from '../SpendingLimitCard.module.css';
import { FormattedCurrency } from '../../../../../iwIntlProvider/FormattedCurrency';
import { tracking } from '@iwoca/frontend-tracking-library';
import { GetBuyerSpendingLimitResponse } from '@iwoca/lapi-client/iwocapay';

export const ValidLimits = ({
    setIsSpendingLimitDrawerOpen,
    spendingLimit
}: {
    setIsSpendingLimitDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
    spendingLimit: GetBuyerSpendingLimitResponse['data']['active_spending_limit'];
}) => {
    return (
        <>
            <div className={styles.leftInnerContainer}>
                <div className={styles.remainingLimitHeader}>
                    <div>
                        You have{' '}
                        <FormattedCurrency
                            className={styles.remainingLimitAmount}
                            value={spendingLimit.available_amount}
                        />{' '}
                        left to spend
                    </div>
                </div>
                <div className={styles.interestRateLabel}>
                    *Interest rate is dependent on supplier
                </div>
            </div>
            <div className={styles.rightInnerContainer}>
                <div className={styles.spendingLimitAmount}>
                    <div>
                        Spending limit:{' '}
                        <FormattedCurrency value={spendingLimit.max_amount} />
                    </div>
                </div>
                <div className={styles.spendingLimitDurationLabel}>
                    {spendingLimit.duration_in_months} month purchases{' '}
                    <button
                        onClick={() => {
                            tracking.ampli.spendingLimitViewedOtherTerms();
                            setIsSpendingLimitDrawerOpen(true);
                        }}
                        className={styles.otherTermsButton}
                    >
                        Other terms
                    </button>
                </div>
            </div>
        </>
    );
};
